module.exports = __webpack_public_path__ + "ofis 2.jpg?873b9774847c3881b39c6b480c92b41c";


//////////////////
// WEBPACK FOOTER
// ./src/HtmlFiles/img/ofis 2.jpg
// module id = 358
// module chunks = 0